/*
	Copyright (C) 2018 Deep Skills Inc., - All Rights Reserved
	Unauthorized copying of this file, via any medium is strictly prohibited
	Proprietary and confidential
*/
import { createBrowserHistory } from "history";
export default createBrowserHistory();